import type { ComponentProps } from 'react';

import type { EventPanel } from '../../../components/global/EventPanel/EventPanel.tsx';

type ParsedEvent = Omit<ComponentProps<typeof EventPanel>, 'onDropdownClick'> & {
  id: string;
  eventsGroup: number | null;
};

interface EventGroup {
  eventsGroup: number;
  events: ParsedEvent[];
  firstDate: Date;
  lastDate: Date;
}

export const groupEventsByGroup = (
  events: ParsedEvent[] | undefined,
): { singles: ParsedEvent[]; groups: EventGroup[] } | undefined => {
  if (!events) {
    return undefined;
  }

  const grouped = new Map<number, ParsedEvent[]>();
  const singles: ParsedEvent[] = [];

  for (const event of events) {
    if (event.eventsGroup == null) {
      singles.push(event);
      continue;
    }

    const existing = grouped.get(event.eventsGroup);
    if (existing) {
      existing.push(event);
    } else {
      grouped.set(event.eventsGroup, [event]);
    }
  }

  const groups: EventGroup[] = [];
  for (const [eventsGroup, groupEvents] of grouped) {
    if (groupEvents.length === 1) {
      singles.push(groupEvents[0]);
      continue;
    }

    groupEvents.sort((a, b) => a.date.getTime() - b.date.getTime());

    const [first] = groupEvents;
    const last = groupEvents.at(-1);
    if (!first || !last) continue;

    groups.push({
      eventsGroup,
      events: groupEvents,
      firstDate: first.date,
      lastDate: last.date,
    });
  }

  groups.sort((a, b) => a.firstDate.getTime() - b.firstDate.getTime());

  return { singles, groups };
};
